import { Package } from 'lucide-react';
import { useCatalogItemImageUrl } from '../hooks/useCatalogItemImageUrl';
import type { CustomerCatalogItem } from '../types/api';

// Shared thumbnail for a catalog item's photo, used in both the admin
// catalog list (CustomerCatalogTab) and the customer-facing Shop - handles
// the uploaded-vs-external-URL distinction (see hasImage's comment in
// types/api.ts) so callers don't have to.
const SIZE_CLASSES = {
  sm: 'h-10 w-10',
  md: 'h-14 w-14',
  lg: 'h-28 w-28',
};

export function CatalogItemThumbnail({
  item,
  size = 'md',
  className = '',
}: {
  item: Pick<CustomerCatalogItem, 'id' | 'name' | 'hasImage' | 'imageUrl'>;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const uploadedUrl = useCatalogItemImageUrl(item.id, item.hasImage);
  const src = uploadedUrl ?? item.imageUrl ?? null;

  return (
    <div
      className={`flex ${SIZE_CLASSES[size]} shrink-0 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-slate-50 ${className}`}
    >
      {src ? (
        <img src={src} alt={item.name} className="h-full w-full object-cover" />
      ) : (
        <Package className={size === 'lg' ? 'h-8 w-8 text-slate-300' : 'h-4 w-4 text-slate-300'} />
      )}
    </div>
  );
}
